import React from 'react';
// eslint-disable-next-line import/no-unresolved
import icon4SVG from 'assets/resources/pages/about-us/4_icon.svg';
import ImgHTML from '../ImgHTML';

export default function AboutUsSummary() {
  return (
    <div className="container">
      <div className="summary-info-beam">
        <div className="element">
          <ImgHTML src={icon4SVG} />
          <b>Last but not least</b>
          <span>We either do things 100% or we don’t bother.</span>
        </div>
      </div>
    </div>
  );
}
